export default "__VITE_ASSET__Blfm5O07__"